/**
 * External Dependencies
 */
import 'jquery';
import menu from './components/menu';

import Vue from 'vue';
import VueTippy from 'vue-tippy';

import MapInteractive from './vue/components/InteractiveMap.vue';

Vue.use(VueTippy);
Vue.component('interactive-map', MapInteractive);

$(() => {
  // console.log('Hello world');
  menu();

  if ($('#interactiveMap').length > 0) {
    new Vue({
      el: '#interactiveMap',
    });
  }
});
